import styles from "./App.module.css";
import {Chat} from "./components/chat/chat";
import Logo from "../../images/logo.svg";

function App() {
  return (
    <div className={styles.page}>
      <img className={styles.logo} src={Logo} alt="Zodiaq" />
      <div className={styles.page_flex_container}>
        <Chat />
      </div>
    </div>
  );
}

export default App;
